var $788d77bcaab07d29$exports = {};
$788d77bcaab07d29$exports = {
    "longPressMessage": `Long press or press Alt + ArrowDown to open menu`
};


export {$788d77bcaab07d29$exports as default};
//# sourceMappingURL=en-US.mjs.map
